<script lang="ts">
	import type { ProductProps } from "../../templates/ProductProps.js";
	import CkEditorContent from "../common/CkEditorContent.svelte";
	import Media from "../common/Media.svelte";

	const {
		contents,
	}: {
		contents: ProductProps["product"]["contents"];
	} = $props();
</script>

{#each contents as content, index (index)}
	<section class="full-width grid-container {index % 2 === 1 ? 'bg-zms-grey' : ''} py-10 md:py-[5.5rem]">
		<div class="container-center flex items-center flex-col gap-11 lg:gap-[5.5rem]">
			{#if content.photo}
				<div
					class="lg:flex flex md:grid md:grid-cols-2 flex-col-reverse lg:flex-row lg:justify-between gap-8 md:gap-[8.25rem] w-full"
					style="direction: ltr;"
				>
					{#if index % 2 === 0}
						<!-- Sudý index: obrázek vpravo -->
						<Media
							wrapperClass="md:order-2 lg:w-[32rem] h-[16rem] md:h-[32rem]"
							class="rounded-2xl md:order-2 object-cover w-full h-full"
							height={512}
							width={512}
							alt={content.text}
							source={content.photo}
						/>
						<div class="flex flex-col md:hidden lg:w-[32rem] lg:flex gap-8 lg:gap-6 lg:order-1">
							<div>
								<CkEditorContent html={content.text} />
							</div>
						</div>
					{:else}
						<!-- Lichý index: obrázek vlevo -->
						<Media
							wrapperClass="md:order-1 lg:w-[32rem] h-[16rem] md:h-[32rem]"
							class="rounded-2xl md:order-2 object-cover w-full h-full"
							height={512}
							width={512}
							alt={content.text}
							source={content.photo}
						/>
						<div class="flex flex-col md:hidden lg:w-[32rem] lg:flex gap-8 lg:gap-6 lg:order-2">
							<div>
								<CkEditorContent html={content.text} />
							</div>
						</div>
					{/if}
					<div class="font-medium text-md/[1.35] lg:text-lg/[1.4] text-optical-black hidden md:block lg:hidden">
						<CkEditorContent html={content.text} />
					</div>
				</div>
			{:else}
				<!-- Pokud není obrázek, zobraz text na celou šířku vycentrovaný -->
				<div class="w-full flex justify-center">
					<div class="lg:w-[70%]" class:text-center={!content.text.includes("<ul>") && !content.text.includes("<ol>")}>
						<CkEditorContent html={content.text} />
					</div>
				</div>
			{/if}
		</div>
	</section>
{/each}
